// extracted by mini-css-extract-plugin
export var aiStarSpin = "_m8-1";
export var spinner = "_m8-0";